/* CB Privé — rifiniture gate (reset/lock + cleanup URL + form passcode).
   Lo sblocco no-flash avviene già inline nell'<head> (vedi theme.liquid).
   Questo file gestisce: reset via ?cbprive=lock, pulizia del parametro
   dall'URL e il mini-form passcode. È inerte se il gate non è attivo. */
(function () {
	var G = window.__cbPriveGate;
	if (!G || !G.active) return;
	var h = document.documentElement;

	var params = null;
	try { params = new URLSearchParams(window.location.search); } catch (e) {}
	var tok = params ? params.get('cbprive') : null;

	// 0) Reset/lock per QA e demo: ?cbprive=lock (o reset) -> ri-blocca
	if (tok === 'lock' || tok === 'reset') {
		try { document.cookie = 'cb_prive_access=;path=/;max-age=0;samesite=lax'; } catch (e) {}
		try { localStorage.removeItem('cb_prive_access'); } catch (e) {}
		h.classList.remove('cb-prive-unlocked');
		h.classList.add('cb-prive-locked');
	}

	// 1) Pulisci il parametro ?cbprive= dall'URL mantenendo gli altri
	try {
		var url = new URL(window.location.href);
		if (url.searchParams.has('cbprive')) {
			url.searchParams.delete('cbprive');
			var qs = url.searchParams.toString();
			window.history.replaceState({}, document.title, url.pathname + (qs ? '?' + qs : '') + url.hash);
		}
	} catch (e) {}

	// 2) Sblocco persistente (usato dal form passcode)
	function unlock() {
		try {
			document.cookie = 'cb_prive_access=' + G.token + ';path=/;max-age=2592000;samesite=lax';
			try { localStorage.setItem('cb_prive_access', G.token); } catch (e) {}
		} catch (e) {}
		h.classList.remove('cb-prive-locked');
		h.classList.add('cb-prive-unlocked');
	}

	// 3) Form passcode (delegato: funziona anche su contenuti caricati dopo)
	document.addEventListener('submit', function (e) {
		var form = e.target.closest && e.target.closest('[data-cbprive-passcode]');
		if (!form) return;
		e.preventDefault();
		var input = form.querySelector('input');
		var val = ((input && input.value) || '').trim();
		var err = form.querySelector('.cbprive-passcode--error');
		if (val === G.token) {
			unlock();
		} else {
			form.classList.add('cbprive-passcode--invalid');
			if (err) err.hidden = false;
		}
		if (input) {
			input.addEventListener('input', function () {
				form.classList.remove('cbprive-passcode--invalid');
				if (err) err.hidden = true;
			}, { once: true });
		}
	});
})();
